
import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Ref
} from "vue-property-decorator";

import api from "@/api";
import { GetRoleForEditOutput, RoleDto, CreateRoleDto } from "@/api/appService";
import { createNgTree, rebuildKeys, getKeys } from "@/utils/tree";
import { ElForm } from 'element-ui/types/form';

@Component
export default class EditRole extends Vue {
  @Ref() readonly dataForm!: ElForm;

  isProcessNodeChange:boolean = false;

  get title() {
    if (this.form!.id) {
      return `编辑 ${this.form.displayName}`;
    } else {
      return "新建";
    }
  }

  @Watch("show")
  async onShowChange(value: boolean) {
    if (value) {
      const loading = this.$loading({
        target: ".el-dialog"
      });
      await api.role
        .getRoleForEdit({ id: this.form!.id })
        .then((res: GetRoleForEditOutput) => {
          this.form = res.role!;
          this.grantedPermissions = res.grantedPermissionNames!;
          // console.log("rebuildKeys", rebuildKeys(this.grantedPermissions));
          this.permissions = res.permissions!;
          this.routesData = createNgTree(
            this.permissions,
            "parentId",
            "id",
            null,
            "children",
            "",
            false,
             'name'
          );
          console.log("routesData", this.routesData);
          const $tree = (this.$refs.tree as any);
          $tree.setCheckedKeys(this.grantedPermissions);
        })
        .finally(() => {
          setTimeout(() => {
            loading.close();
          }, 200);
        });
    } else {
      this.form = { ...this.defaultData };
    }
    this.$nextTick(() => {
      this.dataForm.clearValidate();
    });
  }

  routesData: any[] = [];
  grantedPermissions: any[] = [];
  permissions: any[] = [];

  defaultData: CreateRoleDto | RoleDto = {
    name: undefined,
    displayName: undefined,
    normalizedName: undefined,
    description: undefined,
    grantedPermissions: []
  };

  show = false;
  form: CreateRoleDto = { ...this.defaultData };

  async save() {
    console.log(this.form);

    (this.$refs.dataForm as any).validate(async (valid: boolean) => {
      if (valid) {
        let p = [];
        const $tree = this.$refs.tree as any;
        p = $tree.getCheckedNodes().map((item:any)=>item.key);
        console.log('tree checkedKeys');
        console.log(p);

        if (this.form!.id) {
          await api.role.update({
            body: { ...this.form, grantedPermissions: p }
          });
        } else {
          await api.role.create({
            body: { ...this.form, grantedPermissions: p }
          });
        }
        this.show = false;
        this.$message.success("更新成功");
        this.$emit("onSave");
      }
    });
  }

  handlePermissionNodeCheck(node:any,checked:boolean){
    if(this.isProcessNodeChange){
      return;
    }
    this.isProcessNodeChange = true;
    const $tree = (this.$refs.tree as any);
    this.setAllChildrenChecked($tree,node,checked);

    // set parent checked
    let $node = $tree.getNode(node.key);
    while($node.parent && $node.parent!==null && $node.parent.data && $node.parent.data.id){
      let key = $node.parent.data.key;
      $tree.setChecked(key,true);
      $node = $tree.getNode(key);
    }

    setTimeout(()=>{
      this.isProcessNodeChange = false;
    },100);


  }

  setAllChildrenChecked($tree:any, node:any,checked:boolean){
    if(node.children && node.children.length > 0){
      for(let i = 0;i<node.children.length;i++){
        let child = node.children[i];
        $tree.setChecked(child.id,checked);
        this.setAllChildrenChecked($tree, child,checked);
      }
    }
  }

  cancel() {
    this.show = false;
  }

  roleRule = {
    name: [
      {
        required: true,
        message: "请输入角色编号",
        trigger: "blur"
      },
      {
        type: "string",
        pattern: "^([a-zA-Z]{1}[a-zA-Z0-9]{0,100})$",
        message: "角色编号仅能为字母与数字的组合，且只能以字母开头",
        trigger: "blur"
      },
      {
        max: 100,
        message: "最多100个字符",
        trigger: "blur"
      }
    ],
    displayName: [
      {
        required: true,
        message: "请输入角色名称",
        trigger: "blur"
      },
      {
        max: 100,
        message: "最多100个字符",
        trigger: "blur"
      }
    ],
    description: [
      { required: false },
      {
        max: 200,
        message: "最多200个字符"
      }
    ]
  };
}
